import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Select from 'react-select';
import { isEmpty } from 'lodash'
import Notif from '../../../commonModules/interface/Notif';
import PopUp from '../../../commonModules/interface/PopUp';
import { Box } from '@material-ui/core';
import InputText, { InputSelectMagasin } from '../../../commonModules/interface/form-input-inline';
import { Alert } from '@material-ui/lab';

class PaygoNewSms extends Component {
    //unicodeSmsVal = ['@','Δ','SP','0','¡','P','¿','p','£','_','!','1','A','Q','a','q','$','Φ','"','2','B','R','b','r','¥','Γ','#','3','C','S','c','s','è','Λ','¤','4','D','T','d','t','é','Ω','%','5','E','U','e','u','ù','Π','&','6','F','V','f','v','ì','Ψ','\'','7','G','W','g','w','ò','Σ','(','8','H','X','h','x','Ç','Θ',')','9','I','Y','i','y','LF','Ξ','*',':','J','Z','j','z','Ø','ESC','+',';','K','Ä','k','ä','ø','Æ',',','<','L','Ö','l','ö']
    unicodeSmsVal = " @ΔSP0¡P¿p£_!1AQaq$Φ\"2BRbr¥Γ#3CScsèΛ¤4DTdtéΩ%5EUeuùΠ&6FVfvìΨ'7GWgwòΣ(8HXhxÇΘ)9IYiyLFΞ*:JZjzØESC+;KÄkäøÆ,<LÖlöMNmnÑñOo"
    //unicodeSmsValExtended = ['|', '^', '{', '}', '€', '[', '~', ']', '\\']
    unicodeSmsValExtended = "|^{}€[~]\\"
    maxSizeUnicodeEncoding = 70
    maxSizeUnicodeEncodingFORTWO = 67
    maxCharsEncodedCharacters = 160 
    maxCharsEncodedCharactersFORTWO = 153
    state = {
        userList:[],
        selected: [],
        boxList:[{value:"", label:""}],
        lists: {
            all:[{value:"", label:""}],
            late:[{value:"", label:""}],
            blocked:[{value:"", label:""}],
            ok:[{value:"", label:""}],
            paid:[{value:"", label:""}],
            prospects:[{value:"", label:""}],
            storeClients:[{value:"", label:""}],
            validate:[{value:"", label:""}],
        },

        message: "",
        messageF: false,
        listName:"",
        smsPrice: {
            price: 0,
            currency:""
        },
        errors:{
            message: false,
            listName: false,
        },
        
        notif:{
            title:"", 
            type:"", 
            message:"",
            show:false,
        },
    }
    
    componentDidMount = () => {
        this.fetchSMSPrice()
        const { CLIENTS, PROSPECTS, STORECLI } = this.props;

        console.log('====================================');
        console.log({ CLIENTS, PROSPECTS, STORECLI } );
        console.log('====================================');

        let all = [{value:"", label:""}]
        let ok = [{value:"", label:""}]
        let late = [{value:"", label:""}]
        let blocked = [{value:"", label:""}]
        let paid = [{value:"", label:""}]
        let prospects = [{value:"", label:""}]
        let storeClients = [{value:"", label:""}]
        
        if( !isEmpty(CLIENTS) ){

            Object.values(CLIENTS).forEach( client => {
                all.push(
                    {value: client.resume.idBox, label: client.resume.clientName}
                )
                const { systemStatus } = client.resume;
                if(systemStatus === "OK"){
                    ok.push(
                        {value: client.resume.idBox, label: client.resume.clientName}
                    )
                } else 
                if(systemStatus === "PaymentLate" || systemStatus === "PaygBlocked"){
                    late.push(
                        {value: client.resume.idBox, label: client.resume.clientName}
                    )
                } 
                else  if( systemStatus === "FullyPaid" ){
                    paid.push(
                        {value: client.resume.idBox, label: client.resume.clientName}
                    )
                }
                // else  if( systemStatus === "PaygBlocked" ){
                //     blocked.push(
                //         {value: client.resume.idBox, label: client.resume.clientName}
                //     )
                // }
            })
        }
        if( !isEmpty(PROSPECTS) ){

            Object.values(PROSPECTS).forEach( client => {
                prospects.push(
                    {value: client.ID, label: `${client.Nom} ${client.Prénom}`}
                )
            })
        }
        if( !isEmpty(STORECLI) ){
            Object.values(STORECLI).forEach( client => {
                storeClients.push(
                    {value: client.id, label: `${client.client_lastname} ${client.client_firstname}`}
                )
            })
        }
        this.setState({
            lists: {
                all,
                late,
                blocked,
                ok,
                paid,
                prospects,
                storeClients
            }
        })
    }
    fetchSMSPrice = async () => {
        try{
            const res = await fetch('/message/get/cost',{
                method:'GET',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                credentials: 'same-origin',
            });
            let infos = await res.json();
            console.log({infos});

            if(infos.error){ 
                console.log("[ERROR] get SMS cost ", infos.error);
            } else {
                this.setState({
                    smsPrice: infos.prices || { price: 0, currency:"" },
                })
            }
        } catch(err){
            console.log("[ERROR] get SMS cost ", err);
        }

    }
    
    updateBoxList = (selected) => {
        console.log(`Option selected:`, selected);

        let boxList = []
        selected.map(listName => {
            boxList = boxList.concat(this.state.lists[listName.value])
        })
        let userList = boxList
        this.setState({ 
            selected,
            boxList,
            userList
        });

    }
    handleSelect = (userList) => {
        this.setState({ userList });
        console.log(`Option selected:`, userList);
    }
    handleChange = (e) => {
        const { name, value } = e.target;
        //Check SMS Size
        console.log('DEBUG,',value);
        this.setState({ [name]: value });
    }

    validate = () => {
        let errors = {}
        let noErrors = true
        if( isEmpty(this.state.userList) || (this.state.userList.length === 1 && this.state.userList[0].value === "") ){
            noErrors = false
            errors.userList = "Veuillez choisir au moins 1 destinataire"
        } else {
            errors.userList = ""
        }

        if(isEmpty(this.state.message)){
            noErrors = false
            errors.message = "Veuillez remplir ce Champ"
        } else {
            errors.message = ""
        }
        if(this.props.group && isEmpty(this.state.listName)){
            noErrors = false
            errors.listName = "Veuillez remplir ce Champ"
        } else {
            errors.listName = ""
        }

        this.setState({
            errors
        })
        return noErrors
    }
    handleSubmit = async () => {
        let methodName = "PaygoNewSms handleSubmit"
        const { userList, listName, message } = this.state;

        if(this.validate()){

            let formatUserList = []
            
            userList.map(user => {
                formatUserList.push(user.value)
            })
            try {
                if( this.props.group ) { // send to redux
                    const res = fetch('/message/userList/new',{
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                        },
                        body: JSON.stringify({
                           userList: formatUserList,
                           listName 
                        }),
                        credentials: 'same-origin',
                    })
                    const resp = await res.json()
                    console.log('====================================');
                    console.log({resp});
    
                    if(resp.error){
                        this.notif(true, "danger", "Un problème est survenu, Veuillez rééssayer")
                        console.log("[ERROR] "+ methodName + resp.error);
                    } else {
                        this.notif(true, "info","Groupe créé avec succès")
                        this.props.close()
                    }
                } else {
        
                    const response = await fetch('/message/group/send',{
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                        },
                        body: JSON.stringify({
                        userList: formatUserList,
                        message 
                        }),
                        credentials: 'same-origin',
                    })
                    const resp2 = await response.json()
                    console.log({resp2});
    
                    if(resp2.error !== "OK"){
                        const msg = "ERREUR : "+resp2.error.error.content;
                        console.log(msg);
                        this.notif(true,"danger", msg)
                        console.log("[ERROR] ", methodName , resp2.error);

                    } else {
                        this.notif(true, "info","Sms envoyé avec succès")
                        //Close Windows OR Clear SMS 
                        let timer = setTimeout(() => {
                            this.props.close()
                          }, 2500);
                          return () => clearTimeout(timer);             
                    }
                }    
            } catch (err) {
                console.log('====================================');
                console.log("[ERROR]",{err});
                console.log('====================================');
                this.notif(true, "danger", "Un problème est survenu")
            }

        } else {
            this.notif(true, "danger", "Le formulaire contient des erreurs")
        }
 
    }
    notif = (show, type, msg, title = "") => {
        this.setState({
            notif: {
                title, 
                type, 
                message:msg,
                show
            }
        })
    }
    calculSmsSize = (message ) => {
        console.log('DEBUG',message)
        console.log('DEBUG',message.length)
        let sizeMsg = 0
        let maxSize = this.maxCharsEncodedCharacters
        for (var i=0; i < message.length; i++) {
            var charElem = message.charAt(i);
            if (this.unicodeSmsVal.indexOf(charElem) != -1){
                sizeMsg++
            }else if (this.unicodeSmsValExtended.indexOf(charElem) != -1){
                sizeMsg = sizeMsg+2
            }else{
                sizeMsg ++
                maxSize = this.maxSizeUnicodeEncoding
            }
          }
          console.log('DEBUG',sizeMsg, ' vs ', maxSize)

        if (sizeMsg > maxSize){
            if (maxSize  === this.maxCharsEncodedCharacters){
                maxSize = this.maxCharsEncodedCharactersFORTWO
            }
            if (maxSize  === this.maxSizeUnicodeEncoding){
                maxSize = this.maxSizeUnicodeEncodingFORTWO
            }
        }
        return {size : sizeMsg, maxCarac : maxSize }
    }
    render() {
        console.log("[STATE] PaygoNewSms", this.state);
        // console.table(!isEmpty(this.props.PROSPECTS) && Object.values(this.props.PROSPECTS))
        // let boxList = [
        //     {value:"NUM1", label:"Num de TT"},
        //     {value:"NUM2", label:"Num de AA"},
        //     {value:"NUM3", label:"Num de ZZ"},
        //     {value:"NUM4", label:"Num de FF"},
        // ]
        const { show, message, title, type} = this.state.notif;
        //let maxChars = this.state.maxChars; 
        let infoSMS = this.calculSmsSize(this.state.message)
        let nbChars = infoSMS.size
        let maxChars = infoSMS.maxCarac

        let  nbMessages = Math.ceil(nbChars / maxChars)
        let  remaining = maxChars - ( 
            nbMessages * maxChars - (nbChars % (nbMessages * maxChars) || nbMessages * maxChars)
        )
        return (
            <PopUp
                title={this.props.group ? "Créer un Groupe" : "Créer un SMS"}
                submitAction={this.handleSubmit}
                close={this.props.close}
            >

                {(show && message) &&
                    <Notif
                        show={show} 
                        title={title} 
                        type={type} 
                        message={message} 
                        close={()=>this.notif(false)} 
                    />
                } 
                {/* MOVE TO PARENT */}
            
                {/* <div className="form-group"> */}
                    <InputSelectMagasin
                        options={[
                            // {value:"blocked", label:"Bloqué"},
                            {value:"ok", label:"A Jour"},
                            {value:"late", label:"En Retard"},
                            {value:"paid", label:"Totalement Remboursé"},
                            {value:"prospects", label:"Prospects"},
                            {value:"storeClients", label:"Clients Magasin"},
                        ]}
                        onChange={this.updateBoxList}
                        value={this.state.selected}
                        placeholder="Type de Clients"
                        style={{border: '0', height:"100%"}}
                        isMulti
                        label="Groupe(s)"
                        // closeMenuOnSelect={false}
                        // closeOnSelect={false}
                        // components={makeAnimated()}
                    />
                {/* </div> */}
                {/* <div className={"form-group "+(this.state.errors.userList ? "has-error" : "")}> */}
                    <InputSelectMagasin
                        options={this.state.boxList}
                        onChange={this.handleSelect}
                        value={this.state.userList}
                        placeholder="Destinataire(s)"
                        style={{border: '0', height:"100%"}}
                        isMulti
                        error={this.state.errors.userList }
                        label="Client(s)"
                        // closeMenuOnSelect={false}
                        // closeOnSelect={false}
                        // components={makeAnimated()}
                    />
                    {/* {this.state.errors.userList && <small className="help-block">{this.state.errors.userList}</small> } */}
                {/* </div> */}

                {this.props.group ? (
                    // <div className={"form-group "+(this.state.errors.listName ? "has-error" : "")}>
                    //     <label className="control-label">Nom du groupe</label>
                    //     <input type="text" name="listName" value={this.state.listName} onChange={this.handleChange} className="form-control custom-search" placeholder="Nom du groupe de diffusion" />
                    //     {this.state.errors.listName && <small className="help-block">Ce champ est requis.</small> }
                    // </div>
                    
                    <InputText
                        label="Nom du Groupe"
                        value={this.state.listName} 
                        onChange={this.handleChange}
                        placeholder="Nom du groupe de diffusion"
                        error={this.state.errors.listName}
                    />
                ) : (
                    <InputText

                        error={this.state.errors.message}
                        label="Message"
                        name="message"
                        onChange={this.handleChange}
                        rows="5"
                        helperText={ nbChars > maxChars ?  `Message ${ nbMessages } ${ remaining }` : `${nbChars }/${ maxChars }`}
                        error={this.state.errors.message}
                    />
                )}

                {!this.props.group &&
                    <Box p={2}>
                        <Alert severity="info">
                            <i>
                                Estimation coût: <b>{this.state.userList.length}</b> destinataires x <b>{ nbMessages }</b> sms x <b>{this.state.smsPrice.price}{this.state.smsPrice.currency}</b> = {this.state.userList.length * this.state.smsPrice.price * nbMessages}FCFA
                            </i>
                        </Alert>
                    </Box>
                }
                
            </PopUp>
        );
    }
}

function mapStateToProps(state){// transform elements from store's state into props in this component
    return {
       CLIENTS: state.clients,
       STORECLI: state.inventory.clients,
       PROSPECTS: state.prospects.RESUME
    }
}

export default connect(mapStateToProps )(PaygoNewSms);